import Vue from 'vue';

if (!window.VueInstance) {
  window.VueInstance = Vue;
}

export default window.VueInstance;
